import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "docfile" }
const _hoisted_2 = { class: "icon-wrapper" }

export function render(_ctx, _cache) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, {
        icon: "lock-01",
        class: "icon",
        stroke: "#717680",
        "stroke-width": "1",
        width: "2rem",
        height: "2rem"
      })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "info" }, [
      _createElementVNode("div", { class: "name" }, " Restricted "),
      _createElementVNode("div", { class: "size" }, " Only the chat owner can access this file ")
    ], -1 /* HOISTED */))
  ]))
}